<template>
	<div>
		<div id="hpc">
			<div id="lbimg">
			  	<el-carousel id="hCarousel" :interval="5000" arrow="always">
				    <el-carousel-item v-for="item in tableData" :key="item.images" style="width: 100%;height: 100%;">
				        <img style="width: 100%;height: 100%;object-fit: cover;" :src="item.images">
				    </el-carousel-item>
			  	</el-carousel>
			</div>
		    <div id="headerNave">
		    	<router-link tag="div" :to="{path:'/Social/flowmuseum'}">最新活动</router-link>
		    	<router-link tag="div" :to="{path:'/Social/forum'}">青博名家讲堂</router-link>
		    	<router-link tag="div" :to="{path:'/about/volunteer/volunbm'}">志愿者服务</router-link>
		    	<router-link tag="div" :to="{path:'/Social/explain'}">讲解队伍建设</router-link>
		    	<router-link tag="div" :to="{path:'/about/sjactivity/activity'}">活动预约</router-link>
		    </div>
		    <div id="hr"></div>
		    <div id="sections">
		    	<div id="sects">
		    		<router-view></router-view>
		    	</div>
		    </div>
		</div>
		<div id="hmobile">
			<div style="width: 100%;height: 180px;">
			  	<el-carousel id="mhCarousel" :interval="5000" arrow="always" style="width: 100%;height: 180px;">
				    <el-carousel-item v-for="item in tableData" :key="item.images" style="width: 100%;height: 100%;">
				        <img style="width: 100%;height: 100%;object-fit: cover;" :src="item.images">
				    </el-carousel-item>
			  	</el-carousel>
			</div>
		    <div id="mheaderNave">
		    	<router-link tag="div" :to="{path:'/Social/flowmuseum'}">最新活动</router-link>
		    	<router-link tag="div" :to="{path:'/Social/forum'}">青博名家讲堂</router-link>
		    	<router-link tag="div" :to="{path:'/about/volunteer/volunbm'}">志愿者服务</router-link>
		    </div>
		    <div style="height: 60px;line-height: 60px;margin: 0 auto; width: 100%;">
		    	<router-link style="width: 50%;cursor: pointer;float: left;" tag="div" :to="{path:'/Social/explain'}">讲解队伍建设</router-link>
		    	<router-link tag="div" :to="{path:'/about/sjactivity/activity'}">活动预约</router-link>
		    </div>
		    <div id="mhr"></div>
		    <div id="msections">
		    	<div id="msects">
		    		<router-view></router-view>
		    	</div>
		    </div>
		</div>
	</div>

</template>

<script>
	export default{
		data(){
			return{
				loading: false,
				tableData: [],
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1,
			}
		},
		mounted(){
			if(this.isMobile()){
				document.getElementById("hmobile").style.display = "block";
				this.search();
			}else{
				document.getElementById("hpc").style.display = "block";
				this.handleSearch();
			};
			$("body,html").animate({
			  scrollTop: 0
			}, 1);

		},
		methods:{
			isMobile() {
		        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		        return flag;
		    },
			handleSearch(){
				this.search();
		        let eWidth = document.body.clientWidth;
	    		document.getElementById("hpc").style.width = eWidth + "px";
	    		document.getElementById("lbimg").style.width = eWidth + "px";
	    		document.getElementById("lbimg").style.height = eWidth*0.35 + "px";
	    		document.getElementById("hCarousel").style.width = eWidth + "px";
	    		document.getElementById("hCarousel").style.height = eWidth*0.35 + "px";
		    },
		    search:function(){
	  			let that = this;
	  			let url = this.HOST + '/api/v1/social/cardAll?pageNumber=' + this.pageNum + '&pageSize=100';
	  			this.loading = true;
	  			this.$axios.get(url).then(function(result){
	  				let cData = result.data;
	  				that.pageTotal = cData.data;
	  				that.currentPage = that.pageTotal.pageNum;
	  				that.tableData = cData.data.list;
	  			}).catch(function(error){
	  				console.log(err);
	  			})
	  		}
		}
	}
</script>

<style scoped>
	#hpc{
		display: none;
	}
	#hmobile{
		display: none;
	}
	#headerNave{
		height: 60px;
		line-height: 60px;
		margin: 0 auto;
		width: 1000px;
	}
	#headerNave>div{
		float: left;
		width: 200px;
		cursor: pointer;
	}
	#headerNave>div:hover{
		color: #FF4500;
	}
	#hr{
		border-bottom: 1px solid #dedede;
		width: 100%;
	}
	#sections{
		width: 100%;
	}
	#sects{
		width: 90%;
		margin-left: 5%;
		margin-right: 5%;
	}
	/*MOBILE*/
	#mheaderNave{
		height: 60px;
		line-height: 60px;
		margin: 0 auto;
		width: 100%;
		border-bottom: 1px solid #956f17;
	}
	#mheaderNave>div{
		float: left;
		width: 33.3%;
		cursor: pointer;
	}
	#mheaderNave>div:hover{
		color: #mFF4500;
	}
	#mhr{
		border-bottom: 1px solid #956f17;
		width: 100%;
	}
	#msections{
		width: 100%;
	}
	#msects{
		width: 100%;
	}
	.el-carousel__container{
		height: 180px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Social.vue